import styled from 'styled-components';
import { Row, Col, Button, Image } from 'antd';

interface SectionTitleProps {
	$isSubSteps?: boolean;
}

export const DownloadButton = styled(Button)`
	width: fit-content;
	border-radius: 5px;
	background-color: ${({ theme }) => theme.palette.secondary.white};
`;

interface ConsolidateButtonProps {
	$isConsolidated: boolean;
}

export const ConsolidateButton = styled(Button)<ConsolidateButtonProps>`
	height: 40px;
	width: fit-content;
	border-radius: 5px;
	background-color: ${({ theme }) => theme.palette.secondary.white};

	${({ $isConsolidated }) =>
		$isConsolidated
			? `
				color: #2cc852 !important;
				border: 1px solid #2cc852 !important;
			`
			: ''}

	span:last-child {
		font-size: 15px;
	}
`;

export const ReportContainer = styled(Col)`
	margin-bottom: 20px;
	border-radius: 0.5rem;
	background-color: white;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export const SectionTitle = styled.h2<SectionTitleProps>`
	font-weight: bold;
	margin-left: 40px;
	margin-bottom: ${({ $isSubSteps }) => ($isSubSteps ? '10px' : '30px')};
`;

export const HeaderContainer = styled(Row)`
	padding-top: 40px;
	padding-bottom: 1rem;
	margin-inline: 10px;

	@media (max-width: 1400px) {
		img {
			width: 100px;
		}
		h1,
		h2 {
			font-size: 15px;
		}
	}

	@media (max-width: 1200px) {
		.kinebot-logo-report {
			width: 70px;
		}
	}
`;

export const ImageStyled = styled(Image)`
	padding-inline: 30px;
	max-height: 70px;
	border-radius: 50%;
	min-height: 100px;
	@media (max-width: 1400px) {
		padding-inline: 16px;
		border-radius: 50%;
		min-height: 70px;
	}
`;

export const HeaderTitle = styled.h1`
	text-align: start;
	font-weight: 500;
	font-size: 20px;
	margin: 0 0 0 2rem;
`;
export const HeaderSubTitle = styled.h2`
	text-align: start;
	font-weight: bold;
	font-size: 20px;
	margin: 0 0 0 2rem;
`;

export const FooterStyled = styled(Col)`
	padding: 0 2.5rem;
	margin-bottom: 2.5rem;
	label {
		font-weight: bold;
		font-size: 1.2rem;
	}
	.ant-form-item {
		width: 100%;
	}
	textArea {
		width: 100%;
	}
`;

export const StyledRow = styled(Row)`
	margin-bottom: 0.5rem;
`;

export const Topic = styled.span`
	font-size: 0.8rem;
	font-weight: 600;
	margin-right: 0.5rem;
	@media (min-width: 1600px) {
		font-size: 1rem;
	}
`;

export const Value = styled.span`
	font-size: 0.8rem;
	font-weight: 400;
	@media (min-width: 1600px) {
		font-size: 1rem;
	}
`;
